import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "30",
  width: "30",
  preserveAspectRatio: "xMidYMid meet"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "white" }, [
      _createElementVNode("rect", {
        x: "2.10059",
        y: "0.686523",
        width: "30",
        height: "2",
        rx: "1",
        transform: "rotate(45 2.10059 0.686523)"
      }),
      _createElementVNode("rect", {
        width: "30",
        height: "2",
        rx: "1",
        transform: "matrix(-0.707107 0.707107 0.707107 0.707107 21.8999 0.686523)"
      })
    ], -1)
  ])))
}
export default { render: render }